import { render, staticRenderFns } from "./modalDocument.vue?vue&type=template&id=01e45148&"
import script from "./modalDocument.vue?vue&type=script&lang=js&"
export * from "./modalDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports